import {organisationService} from "@/services/OrganisationService";
import {toast} from "vue3-toastify";
import {i18n} from "./../lang";
import {imageService} from "@/services/ImageService";
import router from "@/router";

const state = {
    organisation: [],
    printerSettings: [],
    isLoadingOrganisationRequest: false,
    editingOrganisation: {
        loading: false
    },
    isCreatingOrg: false
};

const actions = {
    getOrganisation({ dispatch, commit }) {
        commit(mutations.setLoadingRequest.name, true);
        organisationService
            .getOrganisation()
            .then((response) => {
                commit("setLoadingRequest", false);
                commit(mutations.setOrganisation.name, response.data);
            })
            .catch((error) => {
                commit(mutations.setLoadingRequest.name, false, error);
            });
    },
    async updateOrganisation({ commit }, { organisation, orgId, ticketLogoImageUrlFile, logoImageUrlFile, bannerImageUrlFile, kioskBackgroundVideoUrlFile, maxMbForBanner }) {
        commit(mutations.setOrganisationEditRequestStarted.name);

        if (ticketLogoImageUrlFile) {
            try {
                organisation.ticketLogoImageUrl = await imageService.uploadImage(ticketLogoImageUrlFile, orgId);
            } catch (error) {
                console.error("Error uploading image : " + error);
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setEditRequestError.name, error);
                return;
            }
        }

        if (bannerImageUrlFile){
            try {
                organisation.bannerImageUrl = await imageService.uploadImage(bannerImageUrlFile, orgId, Number(maxMbForBanner) / 10, 1920 );
            } catch (error) {
                console.error("Error uploading image : " + error);
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setEditRequestError.name, error);
                return;
            }
        }

        if (logoImageUrlFile){
            try {
                organisation.logoImageUrl = await imageService.uploadImage(logoImageUrlFile, orgId);
            } catch (error) {
                console.error("Error uploading image : " + error);
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setEditRequestError.name, error);
                return;
            }
        }

        if (kioskBackgroundVideoUrlFile){
            try {
                // no compression: browser-image-compression only handles images
                organisation.kioskBackgroundVideoUrl = await imageService.uploadImage(kioskBackgroundVideoUrlFile, orgId, 0, 0, false);
            } catch (error) {
                console.error("Error uploading video : " + error);
                toast.error(i18n.global.t("toast.errorEdit"));
                commit(mutations.setEditRequestError.name, error);
                return;
            }
        }

        organisationService
            .updateOrganisation(organisation)
            .then((response) => {
                toast.success(i18n.global.t("toast.successSave"));
                commit(mutations.setEditRequestSuccess.name);
                commit(mutations.updateOrganisationList.name, response.data);
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setEditRequestError.name, error);
            });
    },
    createOrganisation({ commit, dispatch }, form) {
        commit(mutations.setOrganisationEditRequestStarted.name);
        return organisationService
            .createOrg(form)
            .then(async (response) => {
                await navigator.clipboard.writeText(response?.data?.user?.password || "");
                toast.success(i18n.global.t("toast.successSave"));
                commit(mutations.setEditRequestSuccess.name);
                commit(mutations.updateOrganisationList.name, response);

                const newOrgId = response?.data?.organization?.orgId;

                if (newOrgId != null) {
                    await dispatch('account/switchOrg', Number(newOrgId), { root: true });
                    router.push('/settings');
                } else {
                    console.warn('error:', response);
                }
                return response;
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setEditRequestError.name, error);
                throw error;
            });
    },
};

const mutations = {
    setIsCreatingOrg(state, value) {
        state.isCreatingOrg = value;
    },
  setLoadingRequest(state, isLoading) {
    state.isLoadingOrganisationRequest = isLoading;
  },
  setOrganisation(state, organisation) {
    state.organisation = organisation;
    organisation.printerSettings === null
      ? (state.printerSettings = {
          kitchenTopSpacing: 0,
          kitchenGroupItems: false,
          charactersPerLine: 0,
        })
      : (state.printerSettings = organisation.printerSettings);
  },
  updateOrganisationList(state, organisation) {
    state.organisation = organisation;
  },
  setOrganisationEditRequestStarted(state) {
    state.editingOrganisation.loading = true;
  },
  setEditRequestSuccess(state) {
    state.editingOrganisation.loading = false;
  },
  setEditRequestError(state, errorMessage) {
    state.editingOrganisation = {
      loading: false,
      success: false,
      message: errorMessage,
    };
  },
};

export const organisation = {
    namespaced: true,
    state,
    actions,
    mutations
};
